import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { MatSnackbarSeverity, SnackbarSeverity } from "mat-snackbar-severity";
import * as configtabs from "./../../assets/json/page_tabs.json";
import { BehaviorSubject, Observable } from "rxjs";
import moment from "moment";
import CryptoJS from 'crypto-js';
import * as filter from "../../assets/json/filters.json";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class UtilService {
  shiftList = filter["default"]["shift"];
  showLoader$: BehaviorSubject<any> = new BehaviorSubject(null);
  private secretKey: any = environment.authenticationKey;
  constructor(
    private router: Router,
    private snackBarSeverity: MatSnackbarSeverity
  ) {}
  getLoaderValue(): Observable<any> {
    return this.showLoader$.asObservable();
  }
  setLoaderValue(value) {
    this.showLoader$.next(value);
  }
  getTimeFormat(min) {
    let num = min;
    let h = Math.floor(num / 3600);
    let m = Math.floor((num % 3600) / 60);
    let s = Math.floor((num % 3600) % 60);
    // let hDisplay = h > 0 ? h + (h == 1 ? "" : "") : "";
    // let mDisplay = m > 0 ? m + (m == 1 ? "" : "") : "";
    // let sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return h + " Hrs " + m + " Min";
  }
  secondsToMinSec(sec) {
    // let hr = Math.floor(sec/3600)
    let min = Math.floor(sec / 60);
    let seconds = Math.floor(sec % 60);
    return `${min} min ${seconds} sec`;
  }
  navigatePage(tab: any) {
    this.router.navigate(["page/alert", tab.href]);
  }

  getTabs(screen) {
    let roleSetting: any = localStorage.getItem("roleSetting");
    if (roleSetting && roleSetting != "undefined") {
      roleSetting = JSON.parse(roleSetting);
    } else {
      roleSetting = {};
    }
    if (roleSetting.screens && roleSetting.screens.length > 0) {
      let filterScreen = roleSetting.screens.filter((screenData) => {
        return screenData.tabId == screen;
      });
      if (filterScreen.length > 0) {
        let tabs = filterScreen[0].tabs.filter((e) => {
          return e.selected;
        });
        return tabs;
      } else {
        return configtabs["default"][screen];
      }
    } else {
      return configtabs["default"][screen];
    }
  }

  getAccessForAction(screen, tab, action) {
    let roleSetting: any = localStorage.getItem("roleSetting");
    if (roleSetting && roleSetting != "undefined") {
      roleSetting = JSON.parse(roleSetting);
    } else {
      roleSetting = {};
    }
    if (roleSetting.screens && roleSetting.screens.length > 0) {
      let filterScreen = roleSetting.screens.filter((screenData) => {
        return screenData.tabId == screen;
      });
      if (filterScreen.length > 0) {
        let selectedTabs = filterScreen[0].tabs;
        if (selectedTabs) {
          let filterTab = selectedTabs.filter((tabData) => {
            return tabData.tabId == tab;
          });
          if (filterTab.length > 0) {
            let seletedAction = filterTab[0]?.action?.filter((actionData) => {
              return actionData.actionId == action;
            });
            if (seletedAction && seletedAction.length > 0) {
              let access = seletedAction[0].selected;
              return access;
            } else {
              return filterTab[0].selected;
            }
          } else {
            let tabval = selectedTabs[0].action.filter((actionData) => {
              return actionData.actionId == action;
            });
            if (tabval.length > 0) {
              let access = tabval[0].selected;
              return access;
            } else {
              return false;
            }
          }
        } else {
          let selectedAction = filterScreen[0].action.filter((screenData) => {
            return screenData.actionId == action;
          });
          if (selectedAction) {
            return selectedAction[0].selected;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  setGlobalSelectedAsset(assetcode: string) {
    localStorage.setItem("globalAssetcode", assetcode);
  }

  getGlobalSelectedAsset(data: any) {
    let selectedAsset = {};
    if (localStorage.getItem("globalAssetcode")) {
      let globalAssetcode = localStorage.getItem("globalAssetcode");
      let filterAsset = data.filter((assetData: any) => {
        return assetData.assetcode == globalAssetcode;
      });
      if (filterAsset.length > 0) {
        selectedAsset = filterAsset[0];
      } else {
        selectedAsset = data[0];
      }
    } else {
      selectedAsset = data[0];
    }
    return selectedAsset;
  }

  setGlobalSelectedSection(assetcode: string) {
    localStorage.setItem("globalSection", assetcode);
  }
  showSnakbarMessage(
    severity: any,
    message: string,
    horizontal: any,
    vertical: any
  )
  {
    this.snackBarSeverity.open(severity, message, "", {
      duration: 5000,
      // panelClass: ['blue-snackbar'],
      horizontalPosition: horizontal,
      verticalPosition: vertical,
      
    });
  }
  getGlobalSelectedSection(data: any) {
    let selectedSection: any;
    if (localStorage.getItem("globalSection")) {
      let globalSection = localStorage.getItem("globalSection");
      let filterSection = data.filter((section: any) => {
        return section == globalSection;
      });
      if (filterSection.length > 0) {
        selectedSection = filterSection[0];
      } else {
        selectedSection = data[0];
      }
    } else {
      selectedSection = data[0];
    }
    return selectedSection;
  }
  checkCurrentShift(data) {
    let start = moment().startOf("day").add(data.shiftStart, "hours").valueOf();
    let end = moment().startOf("day").add(data.shiftEnd, "hours").valueOf();
    let current = moment().valueOf();

    if (current >= start && current <= end) {
      return data.shift;
    } else if (data.shift == "Shift B") {
      let start = moment().startOf("day").valueOf();
      let end = moment().startOf("day").add(1, "hours").valueOf();
      if (current >= start && current <= end) {
        return data.shift;
      }
    } else {
      return "not matched";
    }
  }
  disableShifts(selectedDuration) {
    if (selectedDuration == "Today") {
      this.shiftList[0]["disableOption"] = true;
      let f = this.shiftList.filter((s) => {
        return this.checkCurrentShift(s) == s.shift;
      });
      if (f[0].shift == "Shift A") {
        this.shiftList[1]["disableOption"] = false;
        this.shiftList[2]["disableOption"] = true;
        this.shiftList[3]["disableOption"] = true;
      } else if (f[0].shift == "Shift B") {
        this.shiftList[1]["disableOption"] = false;
        this.shiftList[2]["disableOption"] = false;
        this.shiftList[3]["disableOption"] = true;
      } else if (f[0].shift == "Shift C") {
        this.shiftList[1]["disableOption"] = false;
        this.shiftList[2]["disableOption"] = false;
        this.shiftList[3]["disableOption"] = false;
      }
    } else {
      this.shiftList[0]["disableOption"] = false;
      this.shiftList[1]["disableOption"] = false;
      this.shiftList[2]["disableOption"] = false;
      this.shiftList[3]["disableOption"] = false;
    }
    return this.shiftList;
  }
  formatSpecification(data) {
    if (data.specificationType == "Range (Min - Max)") {
      return `${data.min_value} - ${data.max_value} ${data.unit}`;
    } else if (data.specificationType == "Lesserthan (<)") {
      return `< ${data.threshold_value} ${data.unit}`;
    } else if (data.specificationType == "Greaterthan (>)") {
      return `> ${data.threshold_value} ${data.unit}`;
    } else if (data.specificationType == "Equals (=)") {
      return `Equal to ${data.threshold_value} ${data.unit}`;
    } else if (data.specificationType == "Min") {
      return `Min ${data.threshold_value} ${data.unit}`;
    } else if (data.specificationType == "Max") {
      // return `Max ${data.thresh_value} ${data.unit}`;
      return `Max ${data.threshold_value} ${data.unit}`;
    } else if (data.specificationType == "Text") {
      return `${data.threshold_value}`;
    } else {
      return data.specificationType;
    }
  }
  formSpecficationObj(data) {
    let obj = {};
    if (data.specificationType == "Range (Min - Max)") {
      obj["min_value"] = data.min_value;
      obj["max_value"] = data.max_value;
    } else {
      obj["threshold_value"] = data.threshold_value;
    }
    obj["unit"] = data.unit;
    obj["specificationType"] = data.specificationType;
    return obj;
  }
  getAssets(assetData) {
    let roleSetting: any = localStorage.getItem("roleSetting");
    let selectedAsset: any = [];
    let filterAssetData: any;
    if (roleSetting && roleSetting != "undefined") {
      roleSetting = JSON.parse(roleSetting);
    } else {
      roleSetting = {};
    }
    if (roleSetting.assets && roleSetting.assets.length > 0) {
      roleSetting["assets"].forEach((element) => {
        filterAssetData = assetData.filter((assetData) => {
          return assetData.asset == element.asset && element.selected;
        });
        if (filterAssetData.length > 0) {
          filterAssetData[0].selected = true;
          selectedAsset.push(element);
        }
      });
      return selectedAsset;
    }
  }
  getAccessTab() {
    let roleSetting: any = localStorage.getItem("roleSetting");
    if (roleSetting && roleSetting != "undefined") {
      roleSetting = JSON.parse(roleSetting);
    } else {
      roleSetting = {};
    }
    if (roleSetting.screens && roleSetting.screens.length > 0) {
      let filterScreen = roleSetting.screens.filter((screenData) => {
        return screenData.selected;
      });
      if (filterScreen.length > 0) {
        return filterScreen;
      } else {
        return false;
      }
    }
  }
  encrypt(value: any) {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      this.secretKey,
    ).toString();
    return encrypted;
  }
  decrypt(text: any) {
    const decrypted = CryptoJS.AES.decrypt(text, this.secretKey);
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  }
  decryptText(text: any, key: any) {
    try {
      const decrypted = CryptoJS.AES.decrypt(text, key);
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedText);
    } catch (err) {
      return null;
    }
  }
}
